/* eslint-disable no-unused-expressions */
import React from "react";
import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";
import { apiPath } from "../../utility/Constant";

const TeamContentPage = () => {
  const { teamContentApi } = apiPath;
  const [teamContent, teamContentLoading] = useFetch(teamContentApi);
  if (teamContentLoading) {
    return <Loading />;
  }

  const { sectionName, sectionSlogan, title, slogan } = teamContent;

  const data = [
    {
      elementType: "input",
      label: "Home Section Name",
      type: "Text",
      name: "sectionName",
      defaultValue: sectionName,
      required: true,
    },
    {
      elementType: "input",
      label: "Home Section Slogan",
      type: "Text",
      name: "sectionSlogan",
      defaultValue: sectionSlogan,
      required: false,
    },
    {
      elementType: "input",
      label: "Teams Section Title",
      type: "Text",
      name: "title",
      defaultValue: title,
      required: true,
    },
    {
      elementType: "textField",
      label: "Teams Section Slogan",
      type: "Text",
      name: "slogan",
      defaultValue: slogan,
      required: false,
    },
  ];

  const update = (data) => {
    updateData(teamContentApi, data);
  };

  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default TeamContentPage;
